export default __webpack_public_path__ + "static/media/231.5fe66ac9.jpg";